import { FormGroup } from '@blueprintjs/core'
import { DateInput } from '@blueprintjs/datetime'
import { format, parse } from 'date-fns'
import React, { SFC } from 'react'

import { CurrentUser } from '../../app/auth'

import { getLocales } from '../../app/shared'
import { SyncIndicator } from './sync-indicator'
import { DatepickerProps, FieldAdapterProps } from './types'
import { createHelperText, createLabelWithId, createRequiredLabel, getIntent, identity } from './utils'

export type Props = FieldAdapterProps<DatepickerProps>

const DatepickerAdapter: SFC<Props> = ({
  input,
  meta,
  label,
  placeholder,
  helperText,
  disabled = false,
  inline,
  required,
  intent,
  translate = identity,
  enableSyncControl,
  // tslint:disable-next-line:no-empty
  onSyncChange = (fieldName: string, newValue: boolean) => {},
}) => {
  const { id, labelText } = createLabelWithId(input, label)
  const intentType = getIntent(meta, intent)
  const helperTextMessage = createHelperText(meta, helperText, translate)
  const labelInfo = createRequiredLabel(required, translate)

  const reqLabelMod = (
    <>
      {labelInfo}
      {enableSyncControl && (
        <SyncIndicator translate={translate} fieldName={input.name} disabled={disabled} onSyncChange={onSyncChange} />
      )}
    </>
  )

  return (
    <CurrentUser>
      {({ languageCode }) => (
        <FormGroup
          helperText={helperTextMessage}
          label={labelText}
          labelFor={id}
          labelInfo={reqLabelMod}
          intent={intentType}
          inline={inline}
          disabled={disabled}
        >
          <DateInput
            disabled={disabled}
            {...input}
            value={parseDate(input.value)}
            locale={languageCode}
            formatDate={formatDate}
            parseDate={parseDate}
            maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 3))}
          />
        </FormGroup>
      )}
    </CurrentUser>
  )
}

function formatDate(date: Date) {
  const localeSettings = getLocales()

  return format(date, localeSettings.formats.date, { locale: localeSettings.locale })
}

function parseDate(date: string | Date): Date {
  return String(date).length ? parse(date) : null
}

export { DatepickerAdapter }



// WEBPACK FOOTER //
// ./src/modules/forms/datepicker-adapter.tsx